export default __webpack_public_path__ + "static/media/george_geng.3c777dcc.gif";